import {Button, Upload, Typography} from 'antd';
import type {UploadProps} from 'antd';
import React, {useState} from 'react';

interface FileUploadProps {
  onChange?: (file: File) => void;
}

const FileUpload: React.FC<FileUploadProps> = ({onChange}) => {
  const [fileName, setFileName] = useState('');

  const uploadProps: UploadProps = {
    showUploadList: false,
    beforeUpload: (file) => {
      setFileName(file.name);
      onChange?.(file as File);

      return false;
    }
  };

  return (
    <div className="file-upload">
      <Upload {...uploadProps}>
        <Button type="default" className="file-upload-btn">
          Choose File
        </Button>
      </Upload>
      <Typography.Text
        className={`file-upload-name ${!fileName ? 'empty' : ''}`}
      >
        {fileName || 'No file chosen'}
      </Typography.Text>
    </div>
  );
};

export default FileUpload;
